// --- FORMAT HELPERS — pure functions, no React dependencies ------------------

// #807: canonical coercion for a leg's overUnder. overUnder is text at every
// DB/adapter boundary, but a truthy non-string (number/object) can leak from an
// unnormalized in-memory leg — calling .endsWith on it throws and crashes the
// render (Known Bug Hotspot #10 class). Coerce anything that isn't a non-empty
// string to the "Over" default. Behavior-identical for all string/null/empty
// inputs. Shared by every display consumer (SlipTicket, ResultsPage, this file)
// so the guard cannot drift back to a per-site copy.
export function safeOverUnder(v) {
  return (typeof v === "string" && v) ? v : "Over";
}

// Format prop display — preserves X+ format from sportsbook, falls back to Over/Under
export function formatPropLabel(player, overUnder, line) {
  if (!player) return "—";
  const ou = safeOverUnder(overUnder);
  // X+ format (BetMGM style) — e.g. "2+" or "1+"
  if (ou.endsWith("+")) return `${player} ${ou}`;
  // Standard Over/Under
  if (line) return `${player} ${ou} ${line}`;
  return player;
}

// UI critique bug-fix batch (item A): the one money formatter for signed dollar
// figures on History. Sign before the `$` (never "$-40.00"), always two decimals,
// zero carries no sign, and anything non-finite renders the em dash so a bad
// input never shows as "$NaN" or "-$null". `sign:false` drops the "+" only.
export function fmtMoney(n, { sign = true } = {}) {
  if (n == null || (typeof n === "string" && n.trim() === "")) return "—";
  const v = Number(n);
  if (!Number.isFinite(v)) return "—";
  const abs = Math.abs(v).toFixed(2);
  if (abs === "0.00") return "$0.00";
  if (v < 0) return `-$${abs}`;
  return sign ? `+$${abs}` : `$${abs}`;
}
